import { wlodevHostHeader, wlodevSchemeHeader } from './config.js'

export const getFetchURL = (headers: Request['headers'], path: string) => {
    const scheme = headers.get(wlodevSchemeHeader)
    if (!scheme) {
        throw new Error(`${wlodevSchemeHeader} header not found`)
    }

    const host = headers.get(wlodevHostHeader)
    if (!host) {
        throw new Error(`${wlodevHostHeader} header not found`)
    }

    const url = new URL(path, `${scheme}://${host}`)
    return url
}

/**
 * Get the site URL either from the production deployment environment variables or
 * from the local environment variables during the development phase.
 * @returns {null|string} Returns either the site URL or null if url is malformed or not set
 */
export const getSiteURL = () => {
    try {
        const url = new URL(
            process.env.WLODEV_URL ??
                process.env.CMS_URL ??
                'http://localhost:3000'
        )
        return url
    } catch (err) {
        console.error('Error getting site URL:', err)
        return null
    }
}
